import { render, staticRenderFns } from "./legal-notice.vue?vue&type=template&id=10440d02&scoped=true&"
import script from "./legal-notice.vue?vue&type=script&lang=ts&"
export * from "./legal-notice.vue?vue&type=script&lang=ts&"
import style0 from "./legal-notice.vue?vue&type=style&index=0&id=10440d02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10440d02",
  null
  
)

export default component.exports